export { ABORTED } from 'lineupengine';
export var SCHEMA_REF = "https://lineup.js.org/develop/schema.4.0.0.json";
//# sourceMappingURL=interfaces.js.map